import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { ColProps_1 } from "@core/utils/ColProps";
import { __t } from "@core/translation/translation";
import Typography from "@components/Typography";
import Button from "@components/Button";
import clsx from "clsx";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Link } from "react-router-dom";
import useStyles from "./styles";

const HelpComponent = () => {
  const classes = useStyles();
  const list = [
    {
      title: "part1",
      data: [
        {
          id: 0,
          text: __t("Getting started with Fibitex"),
          href: "/gettingStart",
        },
        {
          id: 1,
          text: __t("About Fibitex"),
          href: "/aboutUs",
        },
        {
          id: 2,
          text: __t("Fees"),
          href: "/fees",
        },
        {
          id: 3,
          text: __t("Terms of service"),
          href: "/service",
        },
        {
          id: 4,
          text: __t("Authentication Levels"),
          href: "/authenticationLevels",
        },
      ],
    },
    {
      title: "part2",
      data: [
        {
          id: 5,
          text: __t("Frequently Asked Questions"),
          href: "/frequently",
        },
        {
          id: 6,
          text: __t("User levels"),
          href: "/userLevels",
        },
        {
          id: 7,
          text: __t("weblog"),
          href: "/weblog",
        },
      ],
    },
  ];
  function ListItemsMenu(props) {
    const ListItems = props.data.data.map((section) => (
      <Link to={section.href} key={section.id}>
        <ListItem className={classes.listItem}>
          <ListItemText primary={section.text} className={classes.text} />
        </ListItem>
      </Link>
    ));
    return ListItems;
  }
  return (
    <Grid>
      <div className={classes.root}>
        <div className={classes.nav}>
          <ListItemsMenu data={list[0]} />
        </div>
        <div className={classes.nav}>
          <ListItemsMenu data={list[1]} />
        </div>
      </div>
    </Grid>
  );
};
export default HelpComponent;
